import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from './local-storage';
import { navigateTo } from './navigate-to';

function addQueryParamToAbsoluteUrl(
  url: string,
  key: 'access_token',
  value: string,
) {
  const decodedUrl = decodeURIComponent(url);
  const parsedUrl = new URL(decodedUrl);
  parsedUrl.searchParams.set(key, value);
  return parsedUrl.toString();
}

/**
 * Redirige después del login según el flujo de autenticación.
 *
 * - Si existe un redirect, significa que alguien (una app externa o un módulo remoto) redirigió al dominio actual para loguearse.
 *   Luego de autenticar, devolvemos el control a esa app agregando el token como query param.
 *
 * - Si no hay redirect, se asumirá que el login se hizo directamente en esta app (standalone),
 *   entonces simplemente guardamos el token y navegamos a la home.
 */
export const redirectAfterAuth = (token: string) => {
  const redirect = getLocalStorageItem<string>('redirect');

  if (redirect?.includes('http')) {
    /**
     * Caso 1: Login redirigido desde otra app o módulo remoto
     *
     * Cuando una app externa o un módulo remoto redirige a este dominio para autenticar,
     * debe pasar el redirect como query param (por ejemplo: ?redirect=https://app.bloque.app).
     *
     * Este valor se guarda antes de redirigir a Auth0 porque al hacerlo se pierde el estado original.
     * Luego del login, devolvemos el control a esa URL con el token incluido.
     *
     * Importante: el localStorage es por dominio. Si el login ocurre en auth.bloque.app,
     * el token debe guardarse aquí antes de redirigir a la app original.
     */
    removeLocalStorageItem('redirect');

    const updatedUrl = addQueryParamToAbsoluteUrl(
      redirect,
      'access_token',
      token,
    );

    window.location.href = updatedUrl;
    return;
  }

  /**
   * Caso 2: Login directo en esta app (standalone)
   *
   * No hay redirect guardado, lo que indica que la app se está usando directamente (sin redirección desde otra).
   * Guardamos el token localmente y navegamos a la home.
   */
  setLocalStorageItem('access_token', token);
  navigateTo('/');
};
